module.exports = __webpack_public_path__ + "img/cn.5d831425.svg";